import pick from 'lodash-es/pick';
import omit from 'lodash-es/omit';
import each from 'lodash-es/each';
import merge from 'lodash-es/merge';
import updateStyle from '../css/updateStyle';
import frameProps from '../css/frameProps';
import defaults from './layoutContainer.defaults';
import {renderControls} from '../renderControls';
import getDisabledStyle from '../css/disabledStyle';
import Control from './control';
import lookAndFeel from '../lookAndFeel';
import updateStyleByRef from '../css/updateStyleByRef';


export default class LayoutContainer extends Control {
  renderElement() {
    const control = this;
    const options = this._controlOptions;
    const instance = this.instance;
    const path = this.path;
    if (!control.el) {
      control.el = defaults.createElement(control);
      // delete renderContainer.options;
      if (control.isLayoutMode) {
        control.el.addEventListener('mouseover', function() {
          control.isHover = true;
          control.render();
        });
        control.el.addEventListener('mouseout', function() {
          control.isHover = false;
          control.render();
        });
      }
    }

    const cssStyle = defaults.cssStyle(control);

    // const strOptions = JSON.stringify(options);
    // if (renderContainer.options === strOptions) {
    //   return control.el;
    // }

    // renderContainer.options = strOptions;

    var bodyEl = control.el.getElementsByClassName('body')[0];

    var stylePatch = {};
    var bodyStylePatch = {};

    

    merge(stylePatch, cssStyle.normal);
    merge(bodyStylePatch, cssStyle.body.normal);
    if (control.isHover) {
      merge(stylePatch, cssStyle.hover);
      merge(bodyStylePatch, cssStyle.body.hover);
    }

    if (options.style && options.style.normal) {
      merge(stylePatch, pick(options.style.normal, frameProps.concat('overflow')));
      merge(bodyStylePatch, omit(options.style.normal, frameProps.concat('overflow')));
    }

    merge(stylePatch, control.frameStyle);


    if (control.disabled) {
      merge(stylePatch, getDisabledStyle());
      if (options.style && options.style.disabled) {
        merge(stylePatch, options.style.disabled);
      }

      if (control.isLayoutMode) {
        delete stylePatch.pointerEvents;
      }
    }

    if (instance.options.chartSize && options.layout && options.layout != 'custom') {
      const [x, y] = options.layout.split(',');
      const [w, h] = instance.options.chartSize.split('x');
      const i = (x - 1) * h + (y - 1) * 1;
      const { top, right, bottom, left } = instance.options.grid[i];
      merge(stylePatch, {
        top,
        right,
        bottom,
        left,
        width: 'auto',
        height: 'auto',
      });
    }

    let scheme = lookAndFeel(options.lookAndFeel, stylePatch.height);
    // console.log('scheme', options.lookAndFeel, scheme);
    updateStyleByRef([stylePatch, bodyStylePatch], scheme);

    updateStyle(control.el, stylePatch, control._styleCache.currentStyle);
    control._styleCache.currentStyle = stylePatch;

    updateStyle(bodyEl, bodyStylePatch, control._styleCache.currentBodyStyle);
    control._styleCache.currentBodyStyle = stylePatch;

    if (options.controls) {
      each(options.controls, function(ctrl) {
        ctrl.lookAndFeel = merge({}, options.lookAndFeel, ctrl.lookAndFeel);
        if (!ctrl.style) {
          ctrl.style = {};
        }

        // console.log("pointerEvents: 'auto'");
        ctrl.style.normal = merge({}, ctrl.style.normal, {
          pointerEvents: 'inherit',
        });
      });
      renderControls(instance, path,control.nicePath, bodyEl);
    }

    return control.el;
  }
}
